// src/components/Reports/ReportViewerModal.js
import React, { useEffect, useState } from "react";
import { FaFilePdf, FaFilePowerpoint } from "react-icons/fa";
import "../../styles/ReportViewerModal.css";

export default function ReportViewerModal({
  isOpen,
  onClose,
  report,
  pdfSrc,
  isLoading,
  onDownload,
}) {
  const [frameLoading, setFrameLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setFrameLoading(true);
    }
  }, [isOpen, report?.report_id, pdfSrc]);

  if (!isOpen) return null;

  const title =
    report?.title ||
    `Reporte ${report?.report_id || ""}`;

  // Compatibilidad: si has_pdf no viene todavía,
  // asumimos que el PDF sí existe.
  const hasPdf = report?.has_pdf !== false;
  const hasPptx = report?.has_pptx === true;

  const download = (format) => {
    if (!report) return;
    onDownload?.(report, format);
  };

  return (
    <div
      className="pvm-overlay"
      onMouseDown={onClose}
      role="presentation"
    >
      <div
        className="pvm-modal"
        onMouseDown={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="report-modal-title"
      >
        <div className="pvm-header">
          <div className="pvm-title">
            <h3 id="report-modal-title">{title}</h3>

            {report?.created_at && (
              <span className="pvm-subtitle">
                {report.created_at}
              </span>
            )}
          </div>

          <div className="pvm-actions">
            {hasPdf && (
              <button
                type="button"
                className="pvm-btn pvm-primary"
                onClick={() => download("pdf")}
                disabled={!report}
              >
                <FaFilePdf aria-hidden="true" />
                <span>Descargar PDF</span>
              </button>
            )}

            {hasPptx && (
              <button
                type="button"
                className="pvm-btn pvm-pptx"
                onClick={() => download("pptx")}
                disabled={!report}
              >
                <FaFilePowerpoint aria-hidden="true" />
                <span>Descargar PowerPoint</span>
              </button>
            )}

            <button
              type="button"
              className="pvm-btn pvm-close"
              onClick={onClose}
              aria-label="Cerrar reporte"
            >
              ✕
            </button>
          </div>
        </div>

        <div className="pvm-body">
          {isLoading ? (
            <div className="pvm-loading">
              Cargando vista previa…
            </div>
          ) : !pdfSrc ? (
            <div className="pvm-empty">
              No se pudo obtener la vista previa.
            </div>
          ) : (
            <div className="pvm-viewer">
              {frameLoading && (
                <div className="pvm-loading">
                  Cargando vista previa…
                </div>
              )}

              <iframe
                className="pvm-iframe"
                src={pdfSrc}
                title={title}
                onLoad={() => setFrameLoading(false)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
